import { useQuery } from 'urql';
import { graphql } from '@/gql/graphql';
import useAuthStore from '@/stores/useAuthStore';

const GetCurrentUser = graphql(/* GraphQL */ `
  query GetCurrentUser {
    current_user {
      id
      username
      name
      is_complete
      unseen_message_count
      chat_notification_preference
      notification_counts {
        id
        unseen_notification_count
      }
    }
  }
`);

export default function useCurrentUser() {
  const uid = useAuthStore((state) => state.uid);

  const [{ data }] = useQuery({
    query: GetCurrentUser,
    pause: !uid,
  });

  return data?.current_user;
}
